import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/tattle-api/tattle-api/docs/src/components/default-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Development`}</h1>
    <p>{`Since a lot of the operators depend on platform specific code, we rely on docker to encapsulate the requirements for Feluda. Which means we also use docker heavily for local development`}</p>
    <p>{`To start the service, run `}<inlineCode parentName="p">{`docker-compose up`}</inlineCode>{`.`}</p>
    <h2>{`Debugging`}</h2>
    <p>{`Once the services are running, run `}<inlineCode parentName="p">{`docker ps`}</inlineCode>{` to get the container id of the tattle-api service.
Once you attach a bash shell to it by running `}<inlineCode parentName="p">{`docker exec -it CONTAINER_ID /bin/sh`}</inlineCode>{`, you can begin debugging it.`}</p>
    <p>{`We use debugpy as the debugger.`}</p>
    <ol>
      <li parentName="ol">{`Edit the docker-compose.yml file as target : debug`}</li>
      <li parentName="ol">{`Ensure that the FLASK_ENV environment variable is set to development
`}<inlineCode parentName="li">{`export FLASK_ENV=development`}</inlineCode></li>
      <li parentName="ol">{`run`}</li>
    </ol>
    <deckgo-highlight-code {...{
      "terminal": "carbon",
      "theme": "synthwave"
    }}>{`
          `}<code parentName="deckgo-highlight-code" {...{
        "slot": "code"
      }}>{`python -m debugpy --listen 0.0.0.0:5678 --wait-for-client app.py`}</code>{`
        `}</deckgo-highlight-code>
    <p>{`vscode can then listen on port 5678 to the debugger and intercept breakpoints.`}</p>
    <p>{`Note : `}<inlineCode parentName="p">{`--wait-for-client`}</inlineCode>{` argument makes debugpy wait on executing the given command (starting the app), till a client is listening to it (vscode, in our case)`}</p>
    <p>{`Any changes you make to your source code will trigger an automatic reload
of the server. As long as there's a client like VScode attached to the debug server, you'll be able to iterate on the codebase and debug quickly.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      